// model/hooks/use-section-one-actions.ts
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useRejectSignEntryModal } from "../hooks/use-reject-sign-entry-modal";
import { useUpdateStatusToNewEntryModal } from "../hooks/use-update-status-to-new-entry-modal";

export const useSectionOneActions = (mainJournalData: any, search?: string) => {
  const { handleReject: handleSend } = useRejectSignEntryModal(
    mainJournalData?.mainJournal?.section1?.sectionListId || "",
  );
  const { handleUpdate } = useUpdateStatusToNewEntryModal({
    search: search || "",
    sectionOneId: mainJournalData?.mainJournal?.section1?.sectionId || "",
  });

  const { mutate: deleteSectionEntry } = $journalApi.useMutation(
    "delete",
    "/api/v1/journals/section-one/items/{itemNoVersionId}",
    {
      body: (data: any) => data,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({
            sectionOneId:
              mainJournalData?.mainJournal?.section1?.sectionId || "",
            search,
          }).queryKey,
        });
        queryClient.invalidateQueries({
          queryKey:
            journalsQueries.getSectionOneSignersList(
              mainJournalData?.mainJournal?.section1?.sectionId || "",
            ).queryKey,
        });
      },
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({
            sectionOneId:
              mainJournalData?.mainJournal?.section1?.sectionId || "",
            search,
          }).queryKey,
        });
      },
      onError: (error: any) => {
        const status = error?.response?.status || error?.status;
        const description = status === 409
          ? NOTIFICATION_MESSAGES.ENTRY_DELETE_RELATED_DATA_ERROR // "Есть связанные данные, удаление невозможно выполнить"
          : NOTIFICATION_MESSAGES.ENTRY_DELETE_NOT_POSSIBLE; // "Не удалось удалить запись"
        notification.error({ message: NOTIFICATION_MESSAGES.ENTRY_DELETE_ERROR, /* "Ошибка при удалении записи" */ description });
      },
    },
  );

  return {
    handleSend,
    handleUpdate,
    deleteSectionEntry,
  };
};

